// extracted by mini-css-extract-plugin
module.exports = {"s1snjawg":"s1snjawg","b162fg2w":"b162fg2w"};